import { ComponentContentTypes } from '../types/content-types'
import { ComponentDynamicKey } from '../types/component-dynamic'
import { createEntry } from '../utils/contentful-entry'

const TRIAL_OFFERS = [
  'pro_free_trial',
  'pro_14_day_free_trial',
  'pro_free_trial_for_former_premium',
  'teams_day_one_trial_offer',
]

export const isEligibleForTrial = (specialOffers?: Record<string, boolean>): boolean =>
  !!specialOffers && TRIAL_OFFERS.some((offer) => specialOffers[offer] === true)

export const createTrialCtaDynamic = () =>
  createEntry(ComponentContentTypes.ComponentDynamic, 'TrialCtaButton', {
    internalName: 'TrialCtaButton',
    key: ComponentDynamicKey.TrialCtaButton,
  })
